<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<coso-replicator-page-header [title]="'Settings'"></coso-replicator-page-header>
@if (isSaaS === false && isFailoverBackupInstance) {
<alert type="warning">
  <coso-alert-message>This configuration is taken automatically from main instance, and therefore is read-only.</coso-alert-message>
</alert>
} @if (warningMessage) {
<alert type="warning">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="warningMessage"></div>
  </coso-alert-message>
</alert>
} @if (successMessage) {
<alert type="success" [dismissible]="true" (onClose)="successMessage = undefined">
  <coso-alert-message>{{ successMessage }}</coso-alert-message>
</alert>
} @if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
}

<div class="row flex-xl-nowrap">
  <div class="col-12 col-md-3 col-xl-2 bd-sidebar bd-sidebar-sticky">
    <nav class="bd-links" role="navigation" aria-label="Settings Navigation">
      <div role="tablist" class="bd-sidenav nav nav-pills flex-column mx-2" aria-orientation="vertical">
        <a role="tab" class="nav-link align-items-center d-flex" routerLink="general" routerLinkActive="active" aria-controls="panel" id="tab-general">
          <span class="fa fa-wrench mx-2" aria-hidden="true"></span>General
        </a>
        <a role="tab" class="nav-link align-items-center d-flex" routerLink="behavior" routerLinkActive="active" aria-controls="panel" id="tab-behavior">
          <span class="fa fa-cog mx-2" aria-hidden="true"></span>Behavior
        </a>
        <a role="tab" class="nav-link align-items-center d-flex" routerLink="microsoft-teams" routerLinkActive="active" aria-controls="panel" id="tab-microsoft-teams">
          <svg class="svg-icon mx-2" aria-hidden="true"><use xlink:href="#teamsIcon" /></svg>Microsoft Teams
        </a>
        <a role="tab" class="nav-link align-items-center d-flex" routerLink="event-priority" routerLinkActive="active" aria-controls="panel" id="tab-event-priority">
          <span class="fa fa-sort mx-2" aria-hidden="true"></span>Event priority
        </a>
        <a role="tab" class="nav-link align-items-center d-flex" routerLink="entity-filter" routerLinkActive="active" aria-controls="panel" id="tab-entity-filter">
          <span class="fa fa-filter mx-2" aria-hidden="true"></span>Entity filter
        </a>
        <a role="tab" class="nav-link align-items-center d-flex" routerLink="security-role-filter" routerLinkActive="active" aria-controls="panel" id="tab-security-role-filter">
          <span class="fa fa-lock mx-2" aria-hidden="true"></span>Security role filter
        </a>
        <a role="tab" class="nav-link align-items-center d-flex" routerLink="logs" routerLinkActive="active" aria-controls="panel" id="tab-logs">
          <span class="fa fa-file-text-o mx-2" aria-hidden="true"></span>Logs
        </a>
        <a role="tab" class="nav-link align-items-center d-flex" routerLink="notifications" routerLinkActive="active" aria-controls="panel" id="tab-notifications">
          <span class="fa fa fa-bell mx-2" aria-hidden="true"></span>Notifications
        </a>

        @if (isSaaS === false) {
        <a role="tab" class="nav-link align-items-center d-flex" routerLink="failover" routerLinkActive="active" aria-controls="panel" id="tab-failover">
          <span class="fa fa-code-fork mx-2" aria-hidden="true"></span>Failover
        </a>
        }
      </div>
    </nav>
  </div>

  <div class="col-12 col-md-9 col-xl-10 pl-md-5 bd-content bd-scrollable" id="panel" role="tabpanel" tabindex="0">
    <router-outlet></router-outlet>
  </div>
</div>

@if ({ isDirty: isDirty$ | async, isValid: isValid$ | async }; as state) {
<div class="bd-buttons d-lg-flex justify-content-lg-between align-items-lg-center">
  <div class="col-12 col-lg-4 p-0">
    <a class="btn btn-secondary w-md-100" [routerLink]="['/', 'configuration']"> <span class="fa fa-chevron-left mr-1" aria-hidden="true"></span>Back to Configurations list </a>
  </div>
  <div class="col-12 col-lg-8 p-0 d-lg-flex justify-content-lg-end">
    @if (router.url.indexOf('event-priority') != -1) {
    <button id="resetButton" type="button" class="btn btn-secondary w-md-100 mr-2 mt-lg-0 mt-2" (click)="resetToDefault()" [disabled]="isReadOnly">
      <span class="fa fa-undo mr-1" aria-hidden="true"></span>Reset to defaults
    </button>
    }
    <button id="discardButton" type="button" class="col-lg-2 col-md-12 btn btn-danger w-md-100 mr-2 mt-lg-0 mt-2" (click)="discardChanges()" [disabled]="isReadOnly || !state.isDirty">
      <span class="fa fa-times mr-1" aria-hidden="true"></span>Discard
    </button>
    <button
      id="saveButton"
      type="submit"
      form="settingsForm"
      class="col-lg-2 col-md-12 btn btn-primary w-md-100 mt-lg-0 mt-2"
      (click)="saveSettings()"
      [disabled]="isReadOnly || !state.isDirty || !state.isValid"
    >
      <span class="fa fa-save mr-1" aria-hidden="true"></span>Save
    </button>
  </div>
</div>
}

<svg display="none">
  <symbol width="16" height="16" viewBox="0 0 16 16" id="teamsIcon">
    <g>
      <circle class="st0" cx="8.5" cy="3" r="2.3" />
      <circle class="st0" cx="13.7" cy="3.7" r="1.7" />
      <path
        class="st0"
        d="M15.1,6h-3.9c-0.2,0-0.3,0.1-0.3,0.3v4c0,1.2,0.8,2.2,1.9,2.5c1.3,0.3,2.6-0.6,2.9-1.9c0-0.2,0.1-0.3,0.1-0.5
		V6.7C15.9,6.3,15.5,6,15.1,6z"
      />
      <path
        class="st0"
        d="M7.1,6h4.6c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0,0,0v4.7c0,2.2-1.8,3.9-3.9,3.9c-1.4,0-2.7-0.7-3.4-2
		C5,13.2,4.9,13,4.8,12.8c-0.1-0.2-0.1-0.3-0.2-0.5c-0.1-0.3-0.1-0.7-0.1-1V7.4"
      />
      <path
        class="st0"
        d="M7.3,4H0.8C0.4,4,0.1,4.3,0.1,4.6v6.6c0,0.4,0.3,0.7,0.7,0.7h6.6c0.4,0,0.7-0.3,0.7-0.7V4.6C8,4.3,7.7,4,7.3,4
		z M6,6.4H4.6v3.9h-1V6.4H2.1v-1H6V6.4z"
      />
    </g>
    <path class="st1" d="M-33.6-100.8h88.9v88.9h-88.9V-100.8z" />
  </symbol>
</svg>

<ng-template #validationRef>
  The following settings are not compatible with your group storage and must be modified or removed:
  <ul>
    @for (incompatibility of incompatibilities; track incompatibility) {
    <li>{{ incompatibility }}</li>
    }
  </ul>
  <p>Would you like to remove them and continue?</p>
  <strong class="text-primary">Please note that you will not be able to recover them later.</strong>
</ng-template>
